/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Quick_Workout_WarmupInputs */

const en_us2_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Includes a ${i?.minutes}-minute warm-up`)
};

const pt_br2_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inclui ${i?.minutes} min de aquecimento`)
};

const es_419_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incluye ${i?.minutes} min de calentamiento`)
};

const pt_pt2_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inclui ${i?.minutes} min de aquecimento`)
};

const fr_fr2_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inclut ${i?.minutes} min d'échauffement`)
};

const de_de2_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mit ${i?.minutes} min Aufwärmen`)
};

const it_it2_quick_workout_warmup = /** @type {(inputs: Quick_Workout_WarmupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Include ${i?.minutes} min di riscaldamento`)
};

/**
* | output |
* | --- |
* | "Includes a {minutes}-minute warm-up" |
*
* @param {Quick_Workout_WarmupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_warmup = /** @type {((inputs: Quick_Workout_WarmupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_WarmupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_warmup(inputs)
	if (locale === "es-419") return es_419_quick_workout_warmup(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_warmup(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_warmup(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_warmup(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_warmup(inputs)
	return en_us2_quick_workout_warmup(inputs)
});
export { quick_workout_warmup as "quick-workout.warmup" }